import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: theme.spacing(9) - 1,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
  },
  itemCheckboxWrapper: {
    minWidth: theme.spacing(3),
    paddingLeft: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      minWidth: theme.spacing(7),
    },
  },
  itemText: {
    flex: 1,
    maxWidth: '50%',
  },
  itemActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    minWidth: theme.spacing(10),
    marginLeft: 'auto',
  },
}))

export default useStyles
